// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r1 {
    background: #F7F8FC;
    height: 60px;
}

.audioUploadIcon {
    width: 20px;
    height: 20px;
    font-weight: bold;
}

.audio-posisttion {
    cursor: pointer;
    position: absolute;
    right: 5%;
    top: 2%;
}

.download-icon {
    width: 25px;
    height: 25px;
}

.error-border-album-border {
    border: 2px dotted red;
    padding: 10px;
    border-radius: 6px;
}

.imagedrop-error-border-album-border {
    width: 100%;
    /* width: 40%; */
    height: 70px;
    /* height: 120px; */
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    border-style: dashed;
    border-color: #cbd5e1;
    cursor: pointer;
}

.imagedrop-error-border-album-border {
    border: 2px dotted #ccc;
    padding: 10px;
    border-radius: 8px;
    position: relative;
}

.btn-close-custom {
    position: absolute;
    top: -12px;
    right: -12px;
    background-color: white;
    border: 2px dotted #ccc;
    color: rgb(0, 0, 0);
    border-radius: 50%;
    width: 30px;
    height: 30px;
    font-size: 25px;
    line-height: 16px;
    text-align: center;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-close-custom:hover {
    background-color: white;
    color: rgb(0, 0, 0);
    border-color: #ccc;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Audio/Audio_Management/AudioList.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,OAAO;AACX;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".r1 {\n    background: #F7F8FC;\n    height: 60px;\n}\n\n.audioUploadIcon {\n    width: 20px;\n    height: 20px;\n    font-weight: bold;\n}\n\n.audio-posisttion {\n    cursor: pointer;\n    position: absolute;\n    right: 5%;\n    top: 2%;\n}\n\n.download-icon {\n    width: 25px;\n    height: 25px;\n}\n\n.error-border-album-border {\n    border: 2px dotted red;\n    padding: 10px;\n    border-radius: 6px;\n}\n\n.imagedrop-error-border-album-border {\n    width: 100%;\n    /* width: 40%; */\n    height: 70px;\n    /* height: 120px; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 5px;\n    border-style: dashed;\n    border-color: #cbd5e1;\n    cursor: pointer;\n}\n\n.imagedrop-error-border-album-border {\n    border: 2px dotted #ccc;\n    padding: 10px;\n    border-radius: 8px;\n    position: relative;\n}\n\n.btn-close-custom {\n    position: absolute;\n    top: -12px;\n    right: -12px;\n    background-color: white;\n    border: 2px dotted #ccc;\n    color: rgb(0, 0, 0);\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    font-size: 25px;\n    line-height: 16px;\n    text-align: center;\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.btn-close-custom:hover {\n    background-color: white;\n    color: rgb(0, 0, 0);\n    border-color: #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
